import getOnEnterHandler from './utils/getOnEnterHandler';
import { RAVEN_LOGGED_IN_HOMEPAGE_BETA_FEATURE } from './const';
import { USER_LOGIN_STATUS } from 'apps/user/helpers';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';

import LoggedInHomepage from '[theme-lib]/apps/loggedInHomepage/containers/LoggedInHomepage';

const onReqNotFullfilled = { redirectToPath: '/', shouldSetNoRouteAccess: false };

// Enter handlers suitable for ALTERNATIVE RULES TO LOHP
// Decision making about which page to display.
const handleRedirectToLOHP = getOnEnterHandler(
  USER_LOGIN_STATUS.LOGGED_IN,
  [RAVEN_LOGGED_IN_HOMEPAGE_BETA_FEATURE],
  onReqNotFullfilled
);

export const loggedInHomepageRoute = {
  path: 'home',
  component: LoggedInHomepage,
  onEnterHandlers: [handleRedirectToLOHP],
  gtmPageType: gtmPageTypes.Homepage,
  layoutFullWidth: true,
};
